import {_libs} from "./_libs.js";

/**
 * Cards carousel with custom prev/next buttons (testimonials, ab-history):
 * → moves one card forward (the left card leaves the screen, the next one slides in from the right), ← back.
 * Cards run past the right edge (slidesPerView: 'auto'); buttons are disabled at the ends.
 * Navigation is wired manually (Swiper's Navigation module isn't registered in _libs._swiper).
 * Don't re-create it on the theme's "resizePage" — that would jump back to the first card;
 * _libs._swiper already updates the swiper on resize. swiper.destroy() also removes the arrow listeners,
 * so a slider can be created/destroyed per breakpoint (ab-team: mobile only).
 */
export const initCardsSlider = (slider, prevBtn, nextBtn, params = {}) => {
    let swiper = null;

    const prev = () => swiper?.slidePrev();
    const next = () => swiper?.slideNext();

    const updateNav = () => {
        if (!swiper) return;
        if (prevBtn) prevBtn.disabled = swiper.isBeginning;
        if (nextBtn) nextBtn.disabled = swiper.isEnd;
    };

    swiper = _libs._swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 700,
        grabCursor: true,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        ...params,
        on: {
            init: updateNav,
            slideChange: updateNav,
            reachBeginning: updateNav,
            reachEnd: updateNav,
            // leaving an edge doesn't always change activeIndex (the end is clamped) → no slideChange
            fromEdge: updateNav,
            resize: updateNav,
            destroy: () => {
                prevBtn?.removeEventListener('click', prev);
                nextBtn?.removeEventListener('click', next);
            },
        },
    });

    updateNav();

    prevBtn?.addEventListener('click', prev);
    nextBtn?.addEventListener('click', next);

    return swiper;
};
